var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.125 6.5H14.3C11.5697 6.5 10.2046 6.5 9.1618 7.03134C8.2445 7.49873 7.49873 8.2445 7.03134 9.1618C6.5 10.2046 6.5 11.5697 6.5 14.3V24.7C6.5 27.4303 6.5 28.7953 7.03134 29.8382C7.49873 30.7556 8.2445 31.5013 9.1618 31.9686C10.2046 32.5 11.5697 32.5 14.3 32.5H24.7C27.4303 32.5 28.7953 32.5 29.8382 31.9686C30.7556 31.5013 31.5013 30.7556 31.9686 29.8382C32.5 28.7953 32.5 27.4303 32.5 24.7V17.875",
    stroke: "#735BF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 26.0007L13.4759 19.0248C14.1106 18.3902 15.1394 18.3902 15.7741 19.0248L21.125 24.3757M21.125 24.3757L25.6635 19.8373C26.298 19.2027 27.327 19.2027 27.9615 19.8373L32.5 24.3757M21.125 24.3757L24.7812 28.032",
    stroke: "#735BF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.25 13L29.25 4.875M29.25 4.875L32.5 8.125M29.25 4.875L26 8.125",
    stroke: "#735BF2",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFiles);
export default __webpack_public_path__ + "static/media/UploadFiles.865a52cea49984912fe911b008411881.svg";
export { ForwardRef as ReactComponent };